import React from 'react';
import DOMPurify from 'dompurify';
import { componentTypes } from '@white-nl/instantsearch-components';

import Picture from '../../../ui/Picture';

export default function Hit({ hit, results }: componentTypes.HitProps) {
  const {
    id,
    url,
    productImages,
    productAttributes,
    isAvailableInSiteRegion,
  } = hit;

  const hitIndex = results.hits.findIndex((h) => h.id === id);
  const lazyLoadImage = hitIndex > 2;

  return (
    <div className="col-12 col-sm-6 col-xl-4 d-flex">
      <a className="card-product" href={url}>
        <div className="card-product-img">
          {!isAvailableInSiteRegion && (
            <span className="badge bg-warning">
              {Craft.t('product', 'Not available in your region')}
            </span>
          )}
          <Picture image={productImages?.[0]} defaultTransform="xxl-min" loading={lazyLoadImage ? 'lazy' : 'eager'} />
        </div>
        <div className="card-product-body">
          {/* eslint-disable-next-line react/no-danger */}
          <h3 dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(productAttributes?.ATR_PIM_title?.value),
          }}
          />
          {productAttributes?.DAT_Subtitle_TXT && (
            // eslint-disable-next-line react/no-danger
            <p dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(productAttributes.DAT_Subtitle_TXT?.value),
            }}
            />
          )}
        </div>
        {productAttributes?.DAT_Keyfeatures_TXT && (
          <div className="card-product-foot">
            <span className="note-check">{(productAttributes.DAT_Keyfeatures_TXT?.value ?? '').slice(0, 48)}</span>
          </div>
        )}
      </a>
    </div>
  );
}
